import {DynamicExpressionEditor} from "../actions/DynamicExpressionEditor";
import {find} from "../common/HasIDUtil";
import {setRightHandSideValue} from "../common/ExpressionEditUtility";
import {resetNumOfWidgets} from "../widgets/FieldWidgetCreator";
import * as widgets from "./Widgets";
import {DropDownListWidget} from "./Widgets";
import {toString} from "../common/FieldTypesUtils";
import {QuestionListWidget} from "./QuestionListWidget";
import {translateMessage, translateTitledId} from "../common/Translator";
import {EditScreenGroup} from "../views/edit/EditScreenGroup";
import {NamaRouterInstance} from "../routing/NamaRouter";
import {NamaKendoWindow} from "../views/NamaKendoWindow";
import * as FieldType from "../constants/FieldType";
import * as notifier from "../common/ErrorsNotification";
import {ajaxJSON, isNullOrUndefined} from "../common/NamaCommon";
import * as urls from "../constants/NamaURLS";
import {getValue} from "../actions/GenericValues";
import {defaultCriteriaForFilterField} from "../views/list/CriteriaFromFilterField";
import {valueCalculatorForQuestionField} from "../grid/NamaGridWidget";
import {createPageGroupsContainer} from "../views/edit/EditScreenLayout";


export class QuestionFieldsEditor extends DynamicExpressionEditor {
    constructor(ownerId) {
        super();
        this.valueWidgets = {};
        this.ownerId = ownerId;
        this.dynamicSelectors = [];
    }

    addDataWidget(widget) {
        let id = widget.id;
        this.valueWidgets[id] = widget;
    }

    rootElement() {
        return this.dialog.content || this.dialog.rootElement;
    }

    setActionPerformer(performer) {
        this.performer = performer;
    }

    setNestActionPerform(nestActionPerform) {
        this.nestActionPerform = nestActionPerform;
    }

    getPlaceExtraFieldFilterId(){
        //TODO: gui 2 missing feature
    }

    getFieldValue(fieldId, row) {
    }

    edit(questionFields, defaultValues, hidden, action, presenter, dialog, currentPresenter) {
        if (!presenter)
            presenter = currentPresenter;
        if (!presenter)
            presenter = NamaRouterInstance.currentPresenter;
        if (dialog && dialog instanceof NamaKendoWindow)
            presenter = dialog;
        let that = this;
        resetNumOfWidgets();
        if (questionFields === null)
            questionFields = [];
        if (hidden === null)
            hidden = [];
        that.dialog = dialog;
        that.firstFocusable = null;
        that.questionFields = questionFields;
        that.questionsWidget = [];
        that.valueWidgets = {};
        /***
         *@type namaTypes.ReportMetadata
         */
        that.reportMetadata = presenter.reportMetaData;
        if (that.reportMetadata && that.reportMetadata.questionsChangeUtil && !presenter.onDataChanged) {
            presenter.onDataChanged = (id, newValue, cellOptions, entityType) => {
                let questionField = that.reportMetadata.questionFields.find(e => e.id === id);
                if (!questionField)
                    return;
                /***
                 *
                 * @type namaTypes.QuestionsChangedRequest
                 */
                let request = {
                    questionId: id,
                    questionsChangeUtil: that.reportMetadata.questionsChangeUtil,
                    reportRef: presenter.reportRef,
                    questions: that.getQuestionFields(),
                    fieldType: questionField.fieldType
                };
                ajaxJSON(urls.OnReportQuestionsChanged, {
                        request: JSON.stringify(request)
                    }, (r) => {
                        /***
                         * @type namaTypes.ListOfGenericValues
                         */
                        let result = r;
                        if (!result || !result.details || !result.details.length)
                            return;
                        for (let value of result.details) {
                            let fieldValue = getValue(value);
                            let widget = that.valueWidgets[value.fieldId];
                            if (!widget)
                                continue;
                            widget.setValue(fieldValue, value.fieldId, -1);
                        }
                    }
                );
            }

        }
        let hasQuestionFields = false;
        if (questionFields) {
            if (presenter) {
                that.metaData = presenter.metaData;
                that.entityType = presenter.entityType;
            }
            let group = new EditScreenGroup();
            group.questionEditor = that;
            group.rootElement = () => {
                return that.rootElement();
            }
            let metaData = presenter && presenter.entityMetaData ? presenter.entityMetaData() : presenter.metaData;
            let groupContainer = createPageGroupsContainer(group);
            let groupHeader = groupContainer.find(".toggle-info");
            group.drawGroup({
                title: ""
            }, metaData, presenter, 0, groupHeader);
            group.groupHandler.addNewLine();
            that.rootElement().append(group.groupHandler.widgetsList);
            for (let questionField of questionFields) {
                if (hidden.contains(questionField.id) || questionField.hidden === true)
                    continue;
                let valueWidget = null;
                if (questionField.list === true) {
                    let listWidget = new QuestionListWidget({owner: that, id: questionField.id, fieldMetadata: {}}, questionField, this,
                        translateTitledId(that.ownerId, questionField));
                    group.groupHandler.addNewLine();
                    group.groupHandler.lastRow.find(".row").append(listWidget.createElement());
                    valueWidget = listWidget;
                    let defaultValue = find(questionField.id, defaultValues);
                    if (defaultValue)
                        listWidget.setValue(defaultValue.value);
                    listWidget.doNotAutoShowList = questionField.doNotAutoShowList;
                } else {
                    group.appendElement(questionField, metaData, presenter);
                    valueWidget = group.groupHandler.lastWidget;
                }

                if (valueWidget == null)
                    continue;
                hasQuestionFields = true;
                if (that.firstFocusable === null && valueWidget.focus)
                    that.firstFocusable = valueWidget;
                if (valueWidget.eSignature)
                    valueWidget.value = null;
                if (valueWidget instanceof DropDownListWidget) {
                    valueWidget.dynamicSelectorUpdater = that;
                }
                that.questionsWidget.push(valueWidget);
                dialog.addDataWidget(valueWidget);
                that.addDataWidget(valueWidget);
                valueWidget.afterAttach();
            }
            for (let questionField_ of questionFields) {
                let addedWidget = that.valueWidgets[questionField_.id];
                if (addedWidget.fieldMetadata.fieldType === FieldType.Reference) {
                    let targetEntity = addedWidget.fieldMetadata.referencedEntityType;
                    if (targetEntity.startsWith("$"))
                        that.registerDynamicSelector(addedWidget, targetEntity.substring(1));
                    addedWidget.defaultCriteria = () => defaultCriteriaForFilterField(questionField_, that.entityType, valueCalculatorForQuestionField(that));
                }
                if (addedWidget instanceof widgets.ReferenceWidget && dialog.title === "selectLegalEntity") {
                    addedWidget.inChangeDimsDialog = true;
                }
                if (questionField_.metaData.defaultValue) {
                    let defaultValue = questionField_.metaData.defaultValue;
                    if (defaultValue) {
                        setRightHandSideValue(addedWidget, questionField_, defaultValue, null, presenter);
                    }
                }
                let defaultValue_ = getDefaultValue(questionField_, defaultValues);
                if (defaultValue_ != null && (!questionField_.list || questionField_.list === false)) {
                    let value = setRightHandSideValue(addedWidget, questionField_, defaultValue_.value,
                        defaultValue_.value, presenter);
                    defaultValue_.objValue = value;
                }
                let enabled = questionField_.metaData.enabled;
                if(isNullOrUndefined(enabled))
                    enabled = true;
                addedWidget.setEnabled(enabled);
            }
            that.updateDynamicSelectors();
            if (hasQuestionFields)
                return that.questionsWidget;
        }
    }

    getQuestionFields() {
        let that = this;
        let filledQuestionFields = [];
        if (that.questionFields) {
            for (let i = 0; i < that.questionFields.length; i++) {
                let questionField = that.questionFields[i];
                let fieldId = questionField.id;
                let widget = that.valueWidgets[fieldId];
                if (widget !== null) {
                    let value = widget.readValueFromElement();
                    let id = that.questionFields[i].id;
                    /**
                     *
                     * @type {namaTypes.DTOFilledQuestionField}
                     */
                    let filledQuestionField = {};
                    filledQuestionField.id = id;
                    let fieldType = questionField.fieldType || questionField.metaData.fieldType;
                    if (questionField.list || fieldType === "Binary")
                        fieldType = null;
                    filledQuestionField.value = toString(fieldType, value);
                    filledQuestionField.objValue = value;
                    filledQuestionFields.push(filledQuestionField);
                }
            }
        }
        return filledQuestionFields;
    }

    updateDynamicSelectors(resetValues) {
        let that = this;
        if (!that.dynamicSelectors)
            return;
        let questionFields = that.getQuestionFields();
        for (let dynamicSelector of that.dynamicSelectors) {
            let filled = find(dynamicSelector.key, questionFields);
            if (filled != null) {
                dynamicSelector.value.changeEntityType(filled.value, resetValues);
            }
        }
    }

    registerDynamicSelector(view, fieldId) {
        let entry = {};
        entry.key = fieldId;
        entry.value = view;
        this.dynamicSelectors.push(entry);
    }

    entityTypeChanged() {

    }

    isAnyRequiredFieldEmpty() {
        let that = this;
        let notFilledRequiredFields = that.getNotFilledRequiredFields();
        let retValue = false;
        if (notFilledRequiredFields && notFilledRequiredFields.length) {
            for (let field of notFilledRequiredFields) {
                notifier.showError({
                    ownerId: field,
                    message: {englishText: translateMessage("pleaseInputRequiredParameters", translateTitledId("", field))}
                });
            }
            retValue = true;
        }
        let notFilledRequiredGroups = that.getNotFilledRequiredGroups();
        if (notFilledRequiredGroups && notFilledRequiredGroups.length) {
            for (let group of notFilledRequiredGroups) {
                notifier.showError({
                    message: {
                        englishText: translateMessage("pleaseInputAtLeastOneOfRequiredGroupParametersWithGroupName",
                            group)
                    }
                });
            }
            retValue = true;
        }
        return retValue;
    }

    getNotFilledRequiredFields() {
        let that = this;
        let fields = [];
        if (!that.questionFields)
            return fields;
        let answers = that.getQuestionFields();
        for (let q of that.questionFields) {
            if (q.required === true) {
                let answer = find(q.id, answers);
                if (!answer || !answer.value) {
                    fields.push(q);
                }
            }
        }
        return fields;
    }

    getNotFilledRequiredGroups() {
        let that = this;
        let groups = [];
        let requiredGroups = {};
        let requiredGroupsWithFilledValues = [];
        if (!that.questionFields)
            return groups;
        let answers = that.getQuestionFields();
        for (let q of that.questionFields) {
            if (q.requiredGroup) {
                if (requiredGroups[q.requiredGroup])
                    requiredGroups[q.requiredGroup].push(q);
                else
                    requiredGroups[q.requiredGroup] = [q];
                let answer = find(q.id, answers);
                if (answer && answer.value) {
                    requiredGroupsWithFilledValues.push(q);
                }
            }
        }
        for (let requiredGroupsKey in requiredGroups) {
            if (requiredGroupsWithFilledValues.includes(requiredGroupsKey))
                continue;
            groups.push(requiredGroupsKey);
        }
        return groups;
    }

    onDataChanged() {

    }
}

export function getDefaultValue(questionField, defaultValues) {
    if (defaultValues) {
        for (let defaultValue of defaultValues) {
            if (defaultValue.id === questionField.id)
                return defaultValue;
        }
    }
    return null;
}